<template>
  <span class="status-tag funding-status" :class="`funding-status--${status}`">
    {{ statusName(status) }}
  </span>
</template>

<script>
import { statusName } from './funding'

export default {
  name: 'FundingStatus',
  props: {
    status: { type: String, required: true },
  },
  methods: { statusName },
}
</script>

<style lang="sass" scoped>
.funding-status
  background-color: $color-text-second

  &--confirmed
    background-color: $color-theme

  &--cancelled
    background-color: $color-error
</style>
